<template>
  <section class="content__more content__narrow">
    <section-title v-t="'p.contentPage.title.meta'"/>
    <ul class="content__more-list">
      <li
        v-if="hasSourceUrl"
        class="content__more-entry content__more-entry--url"
      >
        <span class="content__more-attribute">URL</span>
        <span class="content__more-value">
          <a
            :href="content.source.url"
            target="_blank"
          >
            {{ content.source.url }}
          </a>
        </span>
      </li>
      <li
        v-if="hasSourceName"
        class="content__more-entry"
      >
        <span
          v-t="'p.contentPage.label.source'"
          class="content__more-attribute"
        />
        <span class="content__more-value">{{ content.source.name }}</span>
      </li>
      <li
        v-if="hasAuthor"
        class="content__more-entry"
      >
        <span
          v-t="'p.contentPage.label.author'"
          class="content__more-attribute"
        />
        <span class="content__more-value">{{ content.author }}</span>
      </li>
      <li
        v-if="hasPublishedAt"
        class="content__more-entry"
      >
        <span
          v-t="'p.contentPage.label.publishedAt'"
          class="content__more-attribute"
        />
        <span class="content__more-value">{{ content.publishedAt | fullDate }}</span>
      </li>
      <li class="content__more-entry">
        <span
          v-t="'p.contentPage.label.user'"
          class="content__more-attribute"
        />
        <span class="content__more-value">{{ content.user | fullName }}</span>
      </li>
      <li class="content__more-entry">
        <span
          v-t="'p.contentPage.label.createdAt'"
          class="content__more-attribute"
        />
        <span class="content__more-value">{{ content.createdAt | fullDate }}</span>
      </li>
      <li class="content__more-entry">
        <span
          v-t="'p.contentPage.label.views'"
          class="content__more-attribute"
        />
        <span class="content__more-value">{{ content.views }}</span>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import isBlank from 'is-blank'
import fullDate from '@/filters/fullDate'
import fullName from '@/filters/fullName'
import pluralize from '@/filters/pluralize'
import PageMixin from '@/mixins/pages/Page'

export default {
  mixins: [PageMixin],
  filters: {
    fullDate,
    fullName,
    pluralize
  },
  computed: {
    ...mapState({
      content: state => state.content.content,
    }),
    hasSourceUrl () {
      return this.content && !isBlank(this.content.source.url)
    },
    hasAuthor () {
      return this.content && !isBlank(this.content.author)
    },
    hasPublishedAt () {
      return this.content && !isBlank(this.content.publishedAt)
    },
    hasSourceName () {
      return this.content && !isBlank(this.content.source.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contents/content/ContentMore.vue